import { createAction } from '@reduxjs/toolkit';

export const checkoutResetAction = createAction('checkout/reset');
